import React from 'react';
import radium, { StyleRoot } from 'radium';

const styles = {
  footer: {
    height: 60,
    width: '100%',
    position: 'fixed',
    bottom: 0,
    left: 0,
    zIndex: 50,
    backgroundColor: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '4px 24px 0 24px',
    lineHeight: '60px',
    borderTop: '1px solid #004d9f',
    '@media (max-width: 767px)': {
      padding: '0px 5px',
    }
  },
  title: {
    color: '#004d9f',
    fontSize: 24,
    fontWeight: 500,
    letterSpacing: 1,
    margin: 0,
    '@media (max-width: 767px)': {
      fontSize: 18,
    },
  },
  subtitle: {
    margin: '0 13px 0 0',
    fontSize: 18,
    color: '#004d9f',
    fontWeight: 300,
    opacity: 0.7,
    '@media (max-width: 767px)': {
      fontSize: 15,
    },
  },
};

function Footer() {
  return (
    <StyleRoot style={styles.footer}>
      <h2 style={styles.subtitle}>尊榮享受·聆聽喜悅</h2>
      <h1 style={styles.title}>科林聽力達人</h1>
    </StyleRoot>
  );
}

export default radium(Footer);



// WEBPACK FOOTER //
// ./components/Footer.js